'use client';

import type { ReactNode } from 'react';
import { Cblurbackdrop } from '@/components/ui/Cblurbackdrop/Cblurbackdrop';
import { Cportal } from '@/components/ui/Cportal';
import { useModalStackContext } from './modal-stack-context';
import { getModalBackdropHostProps } from './modal-backdrop-host-model';

/**
 * The single shared modal backdrop. Renders exactly one Cblurbackdrop directly
 * behind the topmost backdrop-wanting entry (Open or Closing), using that
 * entry's config and stack-derived z-index. Purely visual: pointer-events are
 * disabled so each modal's own overlay continues to own click-to-close — the
 * top modal's overlay sits above this backdrop and intercepts dismissal clicks.
 */
export function ModalBackdropHost(): ReactNode {
  const { stack } = useModalStackContext();
  const backdropProps = getModalBackdropHostProps(stack);

  return (
    <Cportal>
      <Cblurbackdrop dataElScope="ModalBackdropHost/ModalStack" {...backdropProps} />
    </Cportal>
  );
}
